import snakeCase from 'lodash/snakeCase';

import { NavigationItemsType } from '@/constants/event-app-navigation-items';
import { IEventConfiguration } from '@/resources/upgrade/EventConfiguration';

export function getPageName(navigationItems: NavigationItemsType, path: string) {
  return navigationItems.find((item) => path.includes(item.route))?.id;
}

export function checkIsEventPagePublic(
  navigationItems: NavigationItemsType,
  path: string,
  eventConfiguration: IEventConfiguration
) {
  const pageName = getPageName(navigationItems, path);

  return pageName
    ? (eventConfiguration[`${snakeCase(pageName)}_page_public` as keyof IEventConfiguration] as boolean)
    : false;
}
